import { TipoenderecoComponent } from './../endereco-components/tipoendereco/tipoendereco.component';
import { TiporeajusteComponent } from './../cliente-components/tiporeajuste/tiporeajuste.component';
import { TipoclienteComponent } from './../cliente-components/tipocliente/tipocliente.component';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { IndicereajusteComponent } from './../cliente-components/indicereajuste/indicereajuste.component';
import { GrupoclienteComponent } from './../cliente-components/grupocliente/grupocliente.component';
import * as CryptoJS from 'crypto-js';
import { RegiaoModel } from './../../model/endereco/regiao.model';
import { RegiaoService } from 'app/service/endereco/regiao.service';
import { ArmazemService } from 'app/service/endereco/armazem.service';
import { AreaService } from 'app/service/cliente/area.service';
import { AreaModel } from 'app/model/cliente/area.model';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatAccordion} from '@angular/material/expansion';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AlfrescoApi } from '@alfresco/js-api';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import {MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService, TranslationService } from '@alfresco/adf-core';
import { ArmazemComponent } from '../endereco-components/armazem/armazem.component';
import { RegiaoComponent } from '../endereco-components/regiao/regiao.component';
import { GrupoProdutoComponent } from '../produto-components/grupo-produto/grupo-produto.component';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  regiao = {} as RegiaoModel;
  regioes: RegiaoModel[];
  loading = false;

  user: any;
  userAdmin = false;
  userAdministrativo = false;
  userAcervo = false;
  userProduto = false;

  adm = true;
  acervo = false;
  solicitacao = false;

  arrayString: string;
  showFiller = false;

  panelOpenState = false;

  constructor(
    public clienteService: ClienteService,
    public areaService: AreaService,
    public armazemSerice: ArmazemService,
    public regiaoService: RegiaoService,
    public dialog: MatDialog,
    translationService: TranslationService,
    private authService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getAuthority();
  }

  getAuthority() {
    // this.loading = true;
      this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_GRUPO_PERMISSION') === true) {
        this.userAdmin = true;
      } else if (this.arrayString.includes('SUPER_USER') === true) {
        this.userAdmin = true;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    let condicionStop = false;
    while (condicionStop === false) {
      if(store !== null) {
        condicionStop = true;
        this.loading = false;
      }
    }
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }

  goVincular() {
    this.router.navigate(['/vincular-empresa']);
  }

  goListarClientesPasta() {
    this.router.navigate(['/listagem-configurar-pasta']);
  }

  goImportarModelo() {
    this.router.navigate(['/importar-modelo']);
  }

  goPermissoesUsuario() {
    this.router.navigate(['listagem-usuarios-permissao']);
  }

  navigateGrupoPermission() {
    this.router.navigate(['/grupo-permissao']);
  }

  openDialogTipoCliente() {
    const dialogRef = this.dialog.open(TipoclienteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogGrupoProdutos() {
    const dialogRef = this.dialog.open(GrupoProdutoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogRamoDeAtividade() {
    const dialogRef = this.dialog.open(RamoAtividadeModel, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogGrupoDeCliente() {
    const dialogRef = this.dialog.open(GrupoclienteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogIndiceReajuste() {
    const dialogRef = this.dialog.open(IndicereajusteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoDeReajuste() {
    const dialogRef = this.dialog.open(TiporeajusteComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogArmazem() {
    const dialogRef = this.dialog.open(ArmazemComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogTipoDeEndereco() {
    const dialogRef = this.dialog.open(TipoenderecoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogRegiao() {
    const dialogRef = this.dialog.open(RegiaoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getRegioes() {
    this.regiaoService.getRegioes().subscribe(data => {
      this.regioes = data.content;
    }, err => {
      console.log(err);
    })
  }

  validateTicket2(){
    const alfrescoApi = new AlfrescoApi({
      hostEcm: 'https://d-pcdocs.pcdocs.com.br'
    });

    const isLoggedIn = alfrescoApi.isLoggedIn();
    if(isLoggedIn){

    } else {

    }
  }

  validateTicket(){
    const alfrescoApi = new AlfrescoApi({
      hostEcm: 'https://d-pcdocs.pcdocs.com.br'
    });

    const ecmTicket = alfrescoApi.getTicketEcm() ;


  }
}



// WEBPACK FOOTER //
// /app/src/app/components/index/index.component.ts